import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { CallStatusType } from '../model';
import { useSelector } from '../store';
import { selectCall, selectLine } from '../store/reducers/janus';
import { ConnectionDownLinkIcon, ConnectionStatusIcon, ConnectionUpLinkIcon } from './icons';
import MediaConstraintSetup from './MediaConstraintSetup';
import css from './PhoneDisplay.module.scss';
import Video from './Video';

const callStatusMap = new Map<CallStatusType, string>()
callStatusMap.set('idle', 'Idling')
callStatusMap.set('incomingcall', 'Incoming Call')
callStatusMap.set('connected', 'Connected')
callStatusMap.set('reconnected', 'Reconnected')
callStatusMap.set('callingOut', 'Calling Out')
callStatusMap.set('ringingOut', 'Ringing Out')
callStatusMap.set('progressOut', 'Progress Out')
callStatusMap.set('hold', 'On Hold')
callStatusMap.set('transferring', 'Transferring')

export default function PhoneDisplay() {
    const line = useSelector(selectLine)
    const call = useSelector(selectCall)

    return <div className={css.display}>
        <Video className={css.video} />
        <div className={css.loggedInUser}>Logged in as {line.displayName} - {line.username}</div>
        {call.status !== 'idle' && <div className={css.caller}>
            {call.peerDisplayName ?? call.peerUsername}
            <div>{callStatusMap.get(call.status)}</div>
        </div>}
        {call.canDial && <MediaConstraintSetup />}
        {call.canHangUp && <div className={css.connectionStatusContainer}>
            <ConnectionDownLinkIcon className={classNames(css.connectionIcon, call.isSlowAudioDownlink && css.slow)} />
            <ConnectionStatusIcon className={css.connectionStatusIcon} />
            <ConnectionUpLinkIcon className={classNames(css.connectionIcon, call.isSlowAudioUplink && css.slow)} />
        </div>}
    </div>
}